import { ROLES_GESTAO_ORCAMENTARIA } from "./departamentosOrcamento";

// Premissas · Viagens: consolida a leitura do ticket médio por projeto (Custos Gerais por
// Projeto) e do ticket médio global/Backoffice (Despesas Gerais) numa única página, só leitura
// (edição continua só admin nos routers de origem). É igual a ROLES_GESTAO_ORCAMENTARIA — o GET
// de ticket por projeto usa essa mesma lista mais ampla (ver backend/routers/custos_gerais_projeto.py).
// Espelha backend/config.py ROLES_PREMISSAS_VIAGEM — mantenha os dois em sincronia.
export const ROLES_PREMISSAS_VIAGEM = ROLES_GESTAO_ORCAMENTARIA;
